var alignment_rtlignore_default = {
  "alignLeft": "fGhYO",
  "textWrapNowrap": "PB8VU",
  "alignRight": "HBFZL",
  "alignCenter": "YLicF",
  "sizeFullWidth": "vdo9L",
  "renderedInTable": "_9yuvY",
  "sizeOriginal": "OiAo0",
  "sizeContent": "_27RY-",
  "sizeSmall": "ILN2e",
  "sizeSmallCenter": "_47Tgb",
  "flex": "Db9ng",
  "LEFT": "wB32D",
  "CENTER": "-gOPv",
  "RIGHT": "_4sl0y",
  "AUTO": "baWVz",
  "JUSTIFY": "o-EbM"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
